
export enum ProcessStatus {
  READY = 'ready',
  RUNNING = 'running',
  FAILED = 'failed',
  SUCCEEDED = 'succeeded'
}
